import { ResourceLanguage } from 'i18next'
import { Translation } from '../translation'

export const french: Translation & ResourceLanguage = {
    pageTitles: {
        coacheeLogin: 'Connectez-vous à votre compte',
        redirecting: 'Redirection…',
    },
    titles: {
        logIn: 'connecter à Sama',
    },
    subTitles: {
        appDownload: "OU TÉLÉCHARGER L'APPLICATION",
    },
    buttons: {
        continue: 'Continuer',
    },
    alt: {
        logo: 'Logo Sama',
    },
    MagicLinkChooser: {
        title: 'Comment continuer ?',
        openInApp: "Continuer sur l'application Sama",
        recommended: 'RECOMMANDÉ',
        continueOnWeb: 'Continuer sur ce navigateur',
        continueToSama: 'Continuer',
        linkExpiredError:
            "Ce lien de connexion n'est plus valide. Il a peut-être expiré ou a déjà été utilisé. Veuillez en demander un nouveau depuis la page de connexion.",
        downloadAppPrompt: "Vous n'avez pas l'application ?",
        downloadAppCta: "Téléchargez l'application Sama",
        openingApp: "Ouverture de l'application Sama…",
        appNotDetected: 'Application non détectée. Redirection vers le store.',
        appStoreBadgeAlt: "Télécharger dans l'App Store",
        playStoreBadgeAlt: 'Disponible sur Google Play',
        alreadyUsedBadge: 'DÉJÀ UTILISÉ',
        linkAlreadyUsedStatus: 'Ce lien de connexion a déjà été utilisé.',
        secureNote: 'Lien de connexion sécurisé à usage unique',
    },
}
